const furLengthOptions = [
    { value: 'short', label: { en: 'Short', es: 'Corto' } },
    { value: 'medium', label: { en: 'Medium', es: 'Medio' } },
    { value: 'long', label: { en: 'Long', es: 'Largo' } },
];

export default furLengthOptions;